import { cx } from './cx';

export interface SpinnerProps {
  size?: 'sm' | 'md';
  /** Announced to screen readers; omit when the surrounding control already says what is loading. */
  label?: string;
  className?: string;
}

/** Indeterminate progress ring in the current text colour. */
export default function Spinner({ size = 'sm', label, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx(
        'inline-block shrink-0 rounded-full border-2 border-current border-t-transparent animate-spin motion-reduce:animate-none',
        size === 'sm' ? 'size-4' : 'size-5',
        className
      )}
    />
  );
}
